
import { defineComponent, ref, unref } from '@nuxtjs/composition-api'
import kebabCase from 'lodash/kebabCase'
import { setupTixPricing } from '~/assets/composition/tix'
import { setupConcertStatus } from '~/assets/i-concert'

export default defineComponent({
  props: {
    title: { type: String, required: false, default: undefined },
    body: { type: String, required: false, default: undefined },
    prices: { type: Array, required: false, default: () => [] },
    room: { type: String, required: false, default: '' },
    additionalEvents: { type: Array, required: false, default: () => [] },
  },
  setup({ prices, additionalEvents }) {
    const activeTab = ref('ticket_prices')
    const { availablePrices, matrix } = setupTixPricing(prices)
    const hasMatrixPricing = unref(matrix)?.zones.length > 0 || false
    // fetch the cancelled label for use in multiple events
    const { concertStatusLabel } = setupConcertStatus('geannuleerd', 'event-detail-page-info-and-tickets')

    // show tab "other_data" if matrix is empty
    if (additionalEvents.length > 0 && hasMatrixPricing === false) {
      activeTab.value = 'other_data'
    }

    return {
      activeTab,
      availablePrices,
      concertStatusLabelCancelled: concertStatusLabel,
      kebabCase,
      matrix,
      updateInfoTicketsTab(tabName) {
        activeTab.value = tabName
      },
    }
  },
  computed: {
    // cssProps() {
    //   return {
    //     '--th-width': 90 / (this.matrix.zones.length + 1) + '%',
    //   }
    // },
  },
})
